var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('section',{staticClass:"is-fullheight"},[_c('div',{staticClass:"mt-0"},[_c('div',{staticClass:"section"},[_c('router-view')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }